export const selectPassengersStatus = (state) => state?.passengers?.status;
export const selectPassengersError = (state) => state?.passengers?.error;
export const selectPassengersList = (state) => state?.passengers?.list;
export const selectPassengersTotal = (state) => state?.passengers?.total;
export const selectPassengersTotalTickets = (state) => state?.passengers?.totalTickets;
export const selectPassengersGenerateTicketsData = (state) => state?.passengers?.generateTicketsData;
export const selectPassengersGeneratePassengersList = (state) => state?.passengers?.generatePassengersList;
